export let all = {}

export let add = ( p ) => {

	all[ p.path ] = p

}